import * as d3 from "d3";
import React from "react";
import { useTheme } from "../../../contexts/ThemeContext";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const ProgressChartItem = ({ course, lang }) => {
  const [loading, setLoading] = React.useState(true);
  const chartRef = React.useRef(null);
  const theme = useTheme();
console.log(course)
  // Datos
  let progress = Number(course.progress) || 0;
  /* if(!course.completed && Number(course.progress) === 100){
    progress = progress - 1
  } */
  const grade = course.grade || "-";

  React.useEffect(() => {
    setLoading(true);
    d3.select(chartRef.current).selectAll("*").remove();

    const width = 140, height = 140, stroke = 24;
    const radius = (width - stroke) / 2;
    const center = width / 2;

    const svg = d3
      .select(chartRef.current)
      .attr("width", width)
      .attr("height", height);

    // Fondo gris (círculo completo)
    svg
      .append("circle")
      .attr("cx", center)
      .attr("cy", center)
      .attr("r", radius)
      .attr("fill", "none")
      .attr("stroke", "#eee")
      .attr("stroke-width", stroke);

    // Arco de progreso
    const arc = d3.arc()
      .innerRadius(radius)
      .outerRadius(radius)
      .startAngle(0)
      .endAngle((2 * Math.PI * progress) / 100);

    svg
      .append("path")
      .attr("d", arc())
      .attr("fill", "none")
      .attr("stroke", theme.colors.backgroundCompletadoLight)
      .attr("stroke-width", stroke)
      .attr("stroke-linecap", "round")
      .attr("transform", `translate(${center},${center})`);

    // Porcentaje en el centro
    svg
      .append("text")
      .attr("x", center)
      .attr("y", center + 8)
      .attr("text-anchor", "middle")
      .attr("font-size", "2rem")
      .attr("font-weight", "700")
      .style("font-weight", "700")
      .attr('font-family', 'Arial, Helvetica, sans-serif')
      .attr("fill", theme.mode === "dark" ? "#fff" : "#222")
      .text(`${Math.round(progress)}%`);

    // Nota final debajo
    svg
      .append("text")
      .attr("x", center)
      .attr("y", center + 32)
      .attr("text-anchor", "middle")
      .attr("font-size", "1rem")
      .attr("fill", theme.mode === "dark" ? "#fff" : "#222")
      .text(grade !== "-" ? `${lang["History"].grade}: ${grade}` : "");

    setLoading(false);
    // eslint-disable-next-line
  }, [theme, course]);

  return (
    <div className="chart-container" style={{ textAlign: "center", margin: "1rem 0" }}>
      {loading && <Skeleton circle={true} width={140} height={140} />}
      <svg ref={chartRef} style={{ display: loading ? "none" : "block" }} />
      <div style={{ marginTop: 8, fontWeight: 500, color: theme.mode === "dark" ? "#fff" : "#222" }}>
        {course.displayname}
      </div>
    </div>
  );
};